function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { useGridRegisterPipeProcessor, gridVisiblePinnedColumnDefinitionsSelector } from '@mui/x-data-grid/internals';
export var useGridColumnPinningPreProcessors = function(apiRef, props) {
    var disableColumnPinning = props.disableColumnPinning;
    var prevAllPinnedColumns = React.useRef([]);
    var reorderPinnedColumns = React.useCallback(function(columnsState) {
        if (columnsState.orderedFields.length === 0 || disableColumnPinning) {
            return columnsState;
        }
        // HACK: This is a hack needed because the pipe processors aren't pure enough. What
        // they should be is `gridState -> gridState` transformers, but they only transform a slice
        // of the state, not the full state. So if they need access to other parts of the state (like
        // the `state.columns.orderedFields` in this case), they might lag behind because the selectors
        // are selecting the old state in `apiRef`, not the state being computed in the current pipe processor.
        var savedState = apiRef.current.state;
        apiRef.current.state = _extends({}, savedState, {
            columns: columnsState
        });
        var visibleColumns = gridVisiblePinnedColumnDefinitionsSelector(apiRef);
        apiRef.current.state = savedState;
        // HACK: Ends here //
        var leftPinnedColumns = visibleColumns.left.map(function(c) {
            return c.field;
        });
        var rightPinnedColumns = visibleColumns.right.map(function(c) {
            return c.field;
        });
        var newOrderedFields;
        var allPinnedColumns = _to_consumable_array(leftPinnedColumns).concat(_to_consumable_array(rightPinnedColumns));
        var orderedFieldsBeforePinningColumns = apiRef.current.caches.columnPinning.orderedFieldsBeforePinningColumns;
        if (orderedFieldsBeforePinningColumns) {
            newOrderedFields = new Array(columnsState.orderedFields.length).fill(null);
            var newOrderedFieldsBeforePinningColumns = _to_consumable_array(newOrderedFields);
            // Contains the fields not added to the orderedFields array yet
            var remainingFields = _to_consumable_array(columnsState.orderedFields);
            // First, we check if the column was unpinned since the last processing.
            // If yes and it still exists, we move it back to the same position it was before pinning
            prevAllPinnedColumns.current.forEach(function(field) {
                if (!allPinnedColumns.includes(field) && columnsState.lookup[field]) {
                    // Get the position before pinning
                    var index = orderedFieldsBeforePinningColumns.indexOf(field);
                    newOrderedFields[index] = field;
                    newOrderedFieldsBeforePinningColumns[index] = field;
                    // This field was already consumed so we prevent from being added again
                    remainingFields.splice(remainingFields.indexOf(field), 1);
                }
            });
            // For columns still pinned, we keep stored their original positions
            allPinnedColumns.forEach(function(field) {
                var index = orderedFieldsBeforePinningColumns.indexOf(field);
                // If index = -1, the pinned field didn't exist in the last processing, it's possibly being added now
                // If index >= newOrderedFieldsBeforePinningColumns.length, then one or more columns were removed
                // In both cases, use the position from the columns array
                // TODO: detect removed columns and decrease the positions after it
                if (index === -1 || index >= newOrderedFieldsBeforePinningColumns.length) {
                    index = columnsState.orderedFields.indexOf(field);
                }
                // The fallback above may make the column to be inserted in a position already occupied
                // In this case, put it in any empty slot available
                if (newOrderedFieldsBeforePinningColumns[index] !== null) {
                    index = 0;
                    while(newOrderedFieldsBeforePinningColumns[index] !== null){
                        index += 1;
                    }
                }
                newOrderedFields[index] = field;
                newOrderedFieldsBeforePinningColumns[index] = field;
                // This field was already consumed so we prevent from being added again
                remainingFields.splice(remainingFields.indexOf(field), 1);
            });
            // The fields remaining are those that're neither pinnned nor were unpinned
            // For these, we spread them across both arrays making sure to not override existing values
            var i = 0;
            remainingFields.forEach(function(field) {
                while(newOrderedFieldsBeforePinningColumns[i] !== null){
                    i += 1;
                }
                newOrderedFieldsBeforePinningColumns[i] = field;
                newOrderedFields[i] = field;
            });
            apiRef.current.caches.columnPinning.orderedFieldsBeforePinningColumns = newOrderedFieldsBeforePinningColumns;
        } else {
            newOrderedFields = _to_consumable_array(columnsState.orderedFields);
            apiRef.current.caches.columnPinning.orderedFieldsBeforePinningColumns = _to_consumable_array(columnsState.orderedFields);
        }
        prevAllPinnedColumns.current = allPinnedColumns;
        var centerColumns = newOrderedFields.filter(function(field) {
            return !leftPinnedColumns.includes(field) && !rightPinnedColumns.includes(field);
        });
        return _extends({}, columnsState, {
            orderedFields: _to_consumable_array(leftPinnedColumns).concat(_to_consumable_array(centerColumns), _to_consumable_array(rightPinnedColumns))
        });
    }, [
        apiRef,
        disableColumnPinning
    ]);
    useGridRegisterPipeProcessor(apiRef, 'hydrateColumns', reorderPinnedColumns);
    var isColumnPinned = React.useCallback(function(initialValue, field) {
        return apiRef.current.isColumnPinned(field);
    }, [
        apiRef
    ]);
    useGridRegisterPipeProcessor(apiRef, 'isColumnPinned', isColumnPinned);
};
